<template>
    <!-- footer -->
    <footer id="st-footer">
        <address>
            <span>ⓒ {{ new Date().getFullYear() }} STARFIELD MARKET. All Right Reserved</span>
        </address>
    </footer>
</template>

<script setup></script>

<script>
    export default {
        name: 'LayoutFooter',
    };
</script>
